import { render } from "./StatusTaskControl.vue?vue&type=template&id=5496a43c&scoped=true"
import script from "./StatusTaskControl.vue?vue&type=script&lang=js"
export * from "./StatusTaskControl.vue?vue&type=script&lang=js"

import "./StatusTaskControl.vue?vue&type=style&index=0&id=5496a43c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5496a43c"]])

export default __exports__